import { render, staticRenderFns } from "./DataLoadingComponent.vue?vue&type=template&id=b3b4d1c6&scoped=true&"
import script from "./DataLoadingComponent.vue?vue&type=script&lang=js&"
export * from "./DataLoadingComponent.vue?vue&type=script&lang=js&"
import style0 from "./DataLoadingComponent.vue?vue&type=style&index=0&id=b3b4d1c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b4d1c6",
  null
  
)

export default component.exports